


























import Vue from 'vue';
import moment from 'moment';
import { Component, Prop } from "vue-property-decorator";
import camelcase from 'lodash.camelcase';
import * as _ from 'lodash';

@Component({})
export default class NotifyComponent extends Vue  {
    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    data() {
        // @ts-ignore
        return this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
    }

    /*
            * _nfConfirm : The confirm() method displays a dialog box with a specified message, along with an OK and a Cancel button
            * Index - delete item
            * id - primary key value
        */
    _nfConfirm() {
        let context = this.$store.state[this.$store.state.notify.name];

        if (context.notify.type == 'save') {
            this.$store.dispatch('Update', { record: context.notify.item, updateActions: context.actions.updateAction, context: context, self: this});
            context.notify.enabled = false;
        }

        if (context.notify.type == 'close') {
            if (window.location.hash == "") {
                history.back();
            } else if (window.location.hash != "") {
                let pathname = window.location.pathname;
                history.back();

                setTimeout(() => {
                    //#.Current component id
                    let componentId = window.location.hash.replace('#', '');

                    if (componentId == "0" && context.componentId != 0) {
                        window.history.go(-1);

                        //#. Check if the component is reloaded the same dashboard
                        if (pathname == window.location.pathname) {
                            setTimeout(() => {
                                componentId = window.location.hash.replace('#', '');
                                context.renderComponent = false;
                                context.componentId = componentId;

                                this.$nextTick(() => {
                                    //#. Add the component back in
                                    context.renderComponent = true;
                                });
                            }, 10);
                        }
                    } else if (context.componentId != componentId) {
                        context.renderComponent = false;
                        context.componentId = componentId;

                        this.$nextTick(() => {
                            //#. Add the component back in
                            context.renderComponent = true;
                        });
                    }
                }, 10);
            } else {
                history.go(-2);
            }

            //#. Remove notify component in DOM
            context.notify.enabled = false;

            return;
        } else if (context.notify.type == 'dashboardClose') {
            let rootState = this.$store.state;

            _.forOwn(context.cards, function (key, val) {
                let componentName = camelcase(key).replace('Component', '');
                componentName = componentName + 'Index';

                if (rootState[componentName] && rootState[componentName].isDirty) {
                    rootState[componentName].isDirty = false;
                    return;
                }
            });

            //#.Method for app close
            this.$store.dispatch('dashboard/appClose', { self: this });

            //#.Triggered with the getTemplate store.dispatch method.
            this.$store.dispatch('dashboard/getTemplate', { context: context, lang: this.$vuetify.lang, close: true });

            //#. Remove notify component in DOM
            context.notify.enabled = false;

        } else if (context.notify.type == 'delete') {
            let deleteActions = context.actions.deleteAction,
                id = 0,
                index = context.formData.indexOf(context.notify.item);

            //#. Remove notify component in DOM
            this.$store.state.notify.enabled = false;

            //#. Primary key id
            id = context.notify.item[context.fields.find(x => x.primaryKey).value];

            //#.Delete action are triggered with the store.dispatch method.
            this.$store.dispatch('Delete', { id, deleteActions, context, index });

            return;
        } else if (context.notify.type == 'tooltip') {
            let index = context.tooltipsFormData.indexOf(context.notify.item);
            index = context.tooltipsFormData.indexOf(context.notify.item);

            //#. Remove notify component in DOM
            this.$store.state.notify.enabled = false;
            context.isDirty = false;

            //#.When user click the close button input value resetted
            _.forOwn(context.tooltipsList, function (name, val) {
                if (context.tooltipsFormData[index]["FieldName"] == name.key)
                    context.tooltipsFormData[index]["Description"] = name.value;
            });

            //#.When user click the close button reset the edit index
            this.$store.state.tooltip.editedIndex = null;
            return;
        }

        //#.Check if the componet is inline editor
        if (context.inlineEditor.enabled) {
            let index = context.formData.indexOf(context.notify.item);

            //#. Remove notify component in DOM
            this.$store.state.notify.enabled = false;
            context.isDirty = false;
            index = context.tempData.indexOf(context.notify.item);

            //#. Checking for empty row enabled.
            if (index != -1 && context.inlineEditor.emptyRow) {
                _.forOwn(context.notify.item, function (key, val) {
                    let dateFields = context.fields.find(x => x.type == 'Date' && x.value == val);
                    if (dateFields && dateFields.displayCurrentDate) {
                        context.formData[context.editedIndex][val] = moment(new Date).format(key.displayFormat || context.defaultDateFormat);
                    } else {
                        context.formData[context.editedIndex][val] = "";
                    }
                });
                return;
            }

            //#.When user click the close button input value resetted
            _.forOwn(context.editedItem, function (key, val) {
                if (context.formData[context.editedIndex][val] != key)
                    context.formData[context.editedIndex][val] = key;
            });

            //#.When user click the close button reset the edit index
            context.editedIndex = null;
        }
    }

    /*
        * _nfClose event raising methods
    */
    _nfClose() {
        this.$store.state.notify.enabled = false;
    }      
}
